import React from "react";

const OptimizedImage = ({ webpSrc, fallbackSrc, alt, ...props }) => {
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img src={fallbackSrc} alt={alt} {...props} />
    </picture>
  );
};

export default OptimizedImage;
